import * as React from "react"
import { Seo } from "components"
import { Route } from "react-router-dom"
import { AfterPage } from "types/afterjs"
import { NotFound } from "components"

interface Status {
	code: number
}

const Status: React.FC<Status> = ({ code, children }) => {
	return (
		<Route
			render={({ staticContext }) => {
				if (staticContext) staticContext.statusCode = code
				return children
			}}
		/>
	)
}

const NotfoundPage: AfterPage = ({ location }) => {
	return (
		<>
			<Seo
				title="صفحه مورد نظر پیدا نشد"
				description="صفحه‌ایی که به دنبال آن بودید پیدا نشد."
				path={location.pathname}
			/>
			<Status code={404}>
				<NotFound />
			</Status>
		</>
	)
}

export default NotfoundPage
